import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { OutputMapping } from "../OutputMapping/OutputMapping.logic";
import { FinalOutput } from "../FinalOutput/FinalOutput.logic";
import { DetailsTabView } from "../DetailsTab/DetailsTab.View";
import { BandsTypes } from "../Banding/Types";
import { BandingLandingPage } from "../Banding/BandinLandingPage.logic";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  DialogInner,
} from "../../../Common/UI/Index";
import { INotification } from "../../../Notification/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { DialogNavTabs } from "./DialogNavTabs/DialogNavTabs.logic";
import { Navigation } from "./DialogNavTabs/Types";
import { outputHeaderType } from "./OutputConfigDialog.logic";
import "./Styles.scss";
interface OutputConfigDialogViewProps {
  /**
   * Close action
   */
  onCloseDialog: () => void;
  /**
   * Class name to decide if full screen dialog or normal 
   */
  className: string;
  /**
   * Is to show dialog
   */
  isToShow: boolean;
  /**
   * Dialog title
   */
  title: outputHeaderType[] | string;
  /**
   * Selected menu name
   */
  menu: string;
  /**
   * Type of the band
   */
  bandType: BandsTypes;
  /**
   * Handler for save
   */
  onSave: () => void;
  /**
   * Flag to disable the save button
   */
  disabled: boolean;
  /**
   * Notification message items that needs that are currently available in redux state
   */
  notificationItems: INotification[];
  /**
   * True when saved button in output config full dialog is clicked
   */
  isSaveButtonClick: boolean;
}

/**
 * Responsible to render output config dialog
 * @returns output config dialog
 */
export const OutputConfigDialogView: React.FC<OutputConfigDialogViewProps> = (props: OutputConfigDialogViewProps) => {
  const {
    onCloseDialog,
    className,
    isToShow,
    title,
    menu,
    bandType,
    onSave,
    disabled,
    notificationItems,
    isSaveButtonClick
  } = props;
  const { t: translate } = useTranslation();
  const bandingFormClassName = {
    [Navigation.BANDING]: bandType?.toLocaleLowerCase(),
    [Navigation.DETAILS]: "details",
    [Navigation.OUTPUT_CONFIG]: "output-config",
    [Navigation.FINAL_OUTPUT]: "final-output"
  };

  return (
    <div id="ebt-outputConfig-dialog">
      {isToShow &&
          <Dialog
            open={isToShow}
            className={className}
            onOpenChange={onCloseDialog}
            preventBackdropClose={true}
          >
            <DialogInner className={className}>
              <DialogHeader
                id="ebt-outputConfig-dialog-header"
              >
                <div className="output_header_container">
                  {title &&
                    (typeof title === "string"
                      ? translate(title)
                      : title.map((item: outputHeaderType) => (
                        <div key={item.key} className="output_header">
                          <div
                            className="output_title"
                            id="ebt-outputConfig-dialog-title-key"
                          >
                            {translate(item.key)}
                          </div>
                          <div
                            className="output_value"
                            id="ebt-output-config-dialog-title-value"
                          >
                            <span title={item.value}>{translate(item.value)}</span>
                          </div>
                        </div>
                      )))}
                </div>
              </DialogHeader>
              <DialogContent>
                <div className={`output-config-dialog-content-wrapper__${bandingFormClassName[menu]}`}>
                  <DialogNavTabs />
                  {menu === Navigation.DETAILS &&
                    <DetailsTabView
                      isDetailsTab={true}
                      notificationItems={notificationItems}
                      isSaveButtonClick={isSaveButtonClick}
                    />}
                  {menu === Navigation.BANDING && <BandingLandingPage />}
                  {menu === Navigation.OUTPUT_CONFIG && <OutputMapping notificationItems={notificationItems} />}
                  {menu === Navigation.FINAL_OUTPUT && <FinalOutput />}
                </div>
              </DialogContent>
              {menu === Navigation.DETAILS && <DialogFooter>
                <ButtonGroup>
                  <Button
                    borderless={true}
                    onClick={onCloseDialog}
                    id="ebt-outputConfig-details-cancel-btn"
                  >
                    {translate("Button.Cancel")}
                  </Button>
                  <Button
                    variant={ButtonVariantType.FILLED}
                    onClick={onSave}
                    disabled={!disabled}
                    id="ebt-outputConfig-details-save-btn"
                  >
                    {translate("Button.Save")}
                  </Button>
                </ButtonGroup>
              </DialogFooter>}
            </DialogInner>
          </Dialog>
      }
    </div>
  );
};
